import React from "react";
import { object, array } from "prop-types";

import RelatedStoriesBlock from "../related-stories-block";
import StoryContent from "../story-content";

import "./story-grid.m.css";

const StoryGrid = ({ story, relatedStories }) => (
  <div styleName="story-grid">
    <StoryContent story={story} />
    <RelatedStoriesBlock relatedStories={relatedStories} />
  </div>
);

StoryGrid.propTypes = {
  story: object,
  relatedStories: array,
};

export default StoryGrid;
